// Brand mark — minimalist cash stacks forming a perfect inverted-U silhouette.
//
// 5 stacks of cash bills (edge-on view), placed adjacent with no horizontal
// gaps. Bill counts 3 / 5 / 7 / 5 / 3 produce a symmetric ∩ profile.
// Solid cash-green bills on a very light mint plate. No accents, no halos,
// no trail — pure silhouette.

interface Props {
  size?: number;
  className?: string;
}

const STACK_BILL_COUNTS = [3, 5, 7, 5, 3] as const;
const BILL_W = 4.4;
const BILL_H = 1.8;
const BILL_GAP = 0.4;
const BASELINE_Y = 27;
const TOTAL_W = STACK_BILL_COUNTS.length * BILL_W;
const START_X = (32 - TOTAL_W) / 2;

function bills(): JSX.Element[] {
  const out: JSX.Element[] = [];
  STACK_BILL_COUNTS.forEach((n, idx) => {
    const x = START_X + idx * BILL_W;
    for (let k = 0; k < n; k++) {
      const y = BASELINE_Y - (k + 1) * BILL_H - k * BILL_GAP;
      out.push(<rect key={`s${idx}b${k}`} x={x} y={y} width={BILL_W} height={BILL_H} rx={0.25} />);
    }
  });
  return out;
}

export default function BrandMark({ size = 32, className }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      role="img"
      aria-label="Cashflow Sentinel"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Plate — very light green */}
      <rect x="0" y="0" width="32" height="32" rx="7" fill="#ecfdf5" />
      {/* Cash stacks — solid cash green */}
      <g fill="#047857">{bills()}</g>
    </svg>
  );
}
